import { createContext } from 'react';

import { PropertyProviderProps } from './types';

export const defaultProperty: PropertyProviderProps = {
  campaignBackgroundColor: 'white',
  campaignIconColor: 'dodgerBlue',
  campaignTextColor: 'midnightBlue',
  cityId: 0,
  cityName: '',
  communeId: 0,
  communeName: '',
  description: '',
  directCredit: false,
  features: [],
  highlightedFeatures: [],
  id: 0,
  mapPreview: '',
  modifiedAt: '',
  operation: 'comprar',
  operationFormatted: '',
  photoCover: '',
  photos: [],
  price: 0,
  pricing: {},
  principalCurrency: '',
  propertyType: '',
  regionId: 0,
  regionName: '',
  relatedProperties: [],
  secondaryCurrency: '',
  sellerEmail: '',
  sellerName: '',
  surface: 0,
  surfaceUnit: '',
  thumbnail: '',
  title: '',
  projectCampaigns: []
};

const PropertyContext = createContext<PropertyProviderProps>(defaultProperty);

export default PropertyContext;
